var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHearticn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49489 2.27012C6.14533 0.697358 3.89484 0.274289 2.20393 1.71447C0.513021 3.15465 0.274965 5.56256 1.60285 7.26586C2.70689 8.68205 6.04811 11.6689 7.14318 12.6356C7.26569 12.7438 7.32695 12.7979 7.39841 12.8191C7.46077 12.8376 7.52901 12.8376 7.59137 12.8191C7.66283 12.7979 7.72408 12.7438 7.8466 12.6356C8.94167 11.6689 12.2829 8.68205 13.3869 7.26586C14.7148 5.56256 14.5058 3.1395 12.7858 1.71447C11.0659 0.289439 8.84445 0.697358 7.49489 2.27012Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearticn);
export default __webpack_public_path__ + "static/media/hearticn.728e92377e1c0e5ecd46f555b5586d69.svg";
export { ForwardRef as ReactComponent };